import React, { FC, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { SearchForm } from '../SearchForm/SearchForm';
import { getTerritoryDiscoveryPageUrl } from '../../services/pagesUrl/getTerritoryDiscoveryPageUrl';
import Typo from '../Typography';
import { TERRITORY_DISCOVERY_RESULTS_PAGE_SIZE, TerritorySortBy } from './constants';
import { TerritoryDiscoverySection } from '../TerritoryDiscoverySection/TerritoryDiscoverySection';
import { TTerritoryDiscoverySectionPlacement } from '../TerritoryDiscoverySection/constants';

type TTerritoryDiscoveryProps = {
  searchTerm: string | null;
  placement?: TTerritoryDiscoverySectionPlacement;
};

export const TerritoryDiscovery: FC<TTerritoryDiscoveryProps> = ({ searchTerm, placement }) => {
  const [sortBy, setSortBy] = useState<TerritorySortBy>(TerritorySortBy.MostTimePoints);

  const defaultValues = {
    search: searchTerm,
  };

  const useFormReturn = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues,
  });

  const searchRef = useRef<HTMLDivElement>(null);

  const onSortBy = (sortBy: string) => {
    setSortBy(sortBy as TerritorySortBy);
  };

  return (
    <div className="w-full flex flex-col items-center gap-6">
      <section className="flex flex-col items-center gap-4 mt-12">
        <Typo className="text-[28px] text-black-700">Discover Territories</Typo>
        <Typo className="text-[#5a5a5a] text-[18px]">
          Explore your niche community where writers and readers connect.
        </Typo>
      </section>
      <section ref={searchRef} className="w-full sm:w-[480px] mt-2">
        <SearchForm
          // @ts-ignore
          useFormReturn={useFormReturn}
          searchResultPageGetter={getTerritoryDiscoveryPageUrl}
          restrictToAuthenticatedUsers={false}
          searchInputPlaceholder="Search for Territories"
          allowEmptySearch
        />
      </section>
      <TerritoryDiscoverySection
        sortBy={sortBy}
        onSort={onSortBy}
        searchTerm={searchTerm}
        take={TERRITORY_DISCOVERY_RESULTS_PAGE_SIZE}
        placement={placement}
        showNewTerritoryButton
      />
    </div>
  );
};
